<template>
  <div class="layout-wrapper-portal">
    <section class="navbartop bg-info shadow-lg" style="background-color: rgb(89 219 43) !important;">
      <div class="container" style="max-width: calc(100vw - 4em);">
        <nav class="navbar flex-column pt-4 navbar-expand-lg navbar-light pb-0" style="margin: 0 -2.25em;">
          <div class="container flex-column">
            <div class="d-flex w-100 justify-content-between flex-column flex-lg-row">
              <Link class="navbar-brand pe-4 text-center" href="/">
                <img src="/img/disperindag.png" alt="Disperindag" />
              </Link>
              <form class="d-flex" action="/pencarian">  
                <button class="navbar-toggler" type="button" @click="navcollapse_show = !navcollapse_show">
                  <span class="navbar-toggler-icon"></span>
                </button>

                <input class="form-control bg-light ms-3" type="search" name="q" placeholder="Cari .." aria-label="Cari .." style="border-top: none;border-left: none;border-right: none;border-radius: 0;outline: none;" />
                <button class="btn btn-success me-2" type="submit" style="border-radius: 0;">
                  <Icon :icon="['fa', 'search']" />
                </button>
                <a href="/auth/login" target="_blank" class="btn text-dark btn-link" style="white-space: nowrap;">
                  <Icon :icon="['fa', 'sign-in']" class="me-2" />
                  <span>Masuk</span>
                </a>
              </form>
            </div>
          </div>
          
          <div class="mt-4 w-100" style="background-color: #49c51d;">
            <div class="container">
              <div class="collapse navbar-collapse mt-4 mt-md-0" :class="{ 'show': navcollapse_show }" style="font-weight: bold;">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                  <li class="nav-item" v-for="(menu, i) in portalmenu" :key="`menu-${i}`">
                    <Link v-if="!menu.childs.length && !menu.opennewtab" class="nav-link text-dark a" :href="menu.url" v-text="menu.urai"></Link>
                    <a v-else-if="!menu.childs.length && menu.opennewtab" class="nav-link text-dark b" target="_blank" :href="menu.url" v-text="menu.urai"></a>
                    <a v-else class="nav-link text-dark dropdown-toggle cp" @click.stop="navdropdown_show == menu.urai ? navdropdown_show = false : navdropdown_show = menu.urai">
                      <span v-text="menu.urai"></span>
                      <Icon :icon="['fa', 'chevron-down']" class="ms-3" />
                    </a>
                    <ul class="dropdown-menu" :class="{ 'show': navdropdown_show == menu.urai }" v-if="menu.childs.length">
                      <li v-for="(sub, ii) in menu.childs" :key="`submenu-${ii}`">
                        <Link v-if="!sub.opennewtab" class="dropdown-item" :href="sub.url" v-text="sub.urai"></Link>
                        <a v-else class="dropdown-item" target="_blank" :href="sub.url" v-text="sub.urai"></a>
                      </li>
                      <!-- <li><hr class="dropdown-divider" /></li> -->
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </section>

    <slot></slot>

    <section class="footer">
      <div class="container">
        <div class="py-5">
          <div class="row">
            <div class="col-md">
              <h6 class="mb-3 fw-bold">HUBUNGI KAMI</h6>
              <p class="text-dark opacity-75 mb-1 fw-bold">Disperindag Provinsi Maluku Utara</p>
              <p class="text-dark mb-2">Jl. Tapak Raya I, Kota Ternate, Maluku Utara</p>
              <p class="text-dark mb-2"><span class="fw-bold">Telp : </span></p>
              <p class="text-dark mb-2"><span class="fw-bold">Fax : </span></p>
              <p class="text-dark mb-2"><span class="fw-bold">Email : </span></p>
            </div>

            <div class="col-md">
              <h6 class="mb-3 fw-bold">LINK TERKAIT</h6>
              <ul class="nav flex-column">
                <li class="pb-2"><a href="https://malutprov.go.id/" class="text-dark">Portal Resmi</a></li>
                <li class="pb-2"><a href="https://opendata.malutprov.go.id/" class="text-dark">Open Data</a></li>
                <li class="pb-2"><a href="http://bappeda.malutprov.go.id/dev/" class="text-dark">BAPPEDA</a></li>
                <li class="pb-2"><a href="https://www.diskominfosan.malutprov.go.id/" class="text-dark">DISKOMINFOSAN</a></li>
                <li class="pb-2"><a href="https://kemenperin.go.id/" class="text-dark">KEMENPERIN</a></li>
                <li class="pb-2"><a href="https://www.kemendag.go.id/id" class="text-dark">KEMENDAG</a></li>
              </ul>
            </div>

            <div class="col-md">
              <h6 class="mb-3 fw-bold">STATISTIK PENGUNJUNG</h6>
              <table class="table table-sm table-success p-4">
                <tbody>
                  <tr class="fw-bold">
                    <td>Pengunjung Hari ini</td>
                    <td>:</td>
                    <td>{{ pengunjung.saatini }}</td>
                  </tr>
                  <tr>
                    <td>Total Pengunjung</td>
                    <td>:</td>
                    <td>{{ pengunjung.pengunjung }}</td>
                  </tr>
                  <tr>
                    <td>Hits hari ini</td>
                    <td>:</td>
                    <td>{{ pengunjung.hitsaatini }}</td>
                  </tr>
                  <tr>
                    <td>Total Hits</td>
                    <td>:</td>
                    <td>{{ pengunjung.hits }}</td>
                  </tr>
                  <tr>
                    <td>Pengunjung Online</td>
                    <td>:</td>
                    <td>{{ pengunjung.online || 1 }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="bg-dark">
      <div class="container">
        <footer class="py-3 text-light">
          <p class="m-0 text-center">Copyright 2022 &copy; Dinas Perindustrian dan Perdagangan - Provinsi Maluku Utara</p>
        </footer>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    portalmenu: Array,
    pengunjung: Object
  },
  data() {
    return {
      navcollapse_show: false,
      navdropdown_show: false,
    }
  },
  mounted() {
    document.addEventListener('click', () => {
      this.navdropdown_show = false;
    });
  }
}
</script>


<style lang="scss">
@import '../../css/bootstrap';
@import '../../css/style';
</style>